import { deleteHoliday } from "./functions";
import { useContext } from "react";
import AuthContext from "../../context/authProvider";
import { formatarData } from "../utils/functions";
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";

const HolidaysList = ({ holidays, refresh }) => {

    const { user } = useContext(AuthContext);

    const handleDelete = async (holiday) => {
        const data = await deleteHoliday(user.token, holiday._id);
        if (data.type === "success") {
            refresh();
        }
    }

    return (
        <GridComponent dataSource={holidays} allowSorting allowPaging pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='name' headerText="Nome" width='100' textAlign="Center" />
                <ColumnDirective field='date' headerText="Data" width='100' textAlign="Center" valueAccessor={(f, d) => { return formatarData(d?.date) }} />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleDelete(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Excluir</button> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page]} />
        </GridComponent>
    )
}

export default HolidaysList;
